import { useRef } from "react";
import { useInView as uv } from "framer-motion";
import deepmerge from "deepmerge";

export const useInView = (threshold = 0.2) => {
  //const [inView, setInView] = useState(false);

  const ref = useRef();
  const inView = uv(ref);
  /*
  const intersection = useIntersection(ref, {
    // rootMargin: "500px 0px 0px 0px",
    threshold,
  });
  useEffect(() => {
    const inViewNow =
      intersection && intersection.intersectionRatio > threshold;
    return setInView(inViewNow);
  }, [intersection, threshold]);
*/
  return [ref, inView];
};

export const STAGGER = {
  viewport: { once: true },
  whileInView: {
    transition: {
      staggerChildren: 0.2,
      when: "beforeChildren",
    },
  },
};

const defaultTransition = {
  stiffness: 100,
  dumping: 30,
  duration: 0.6,
  when: "beforeChildren",
  staggerDirection: 1,
  staggerChildren: 0.2,
};

export const FADE_UP = {
  initial: { opacity: 0, y: 60 },
  whileInView: { opacity: 1, y: 0, transition: defaultTransition },
  viewport: { once: true },
};

export const FADE_LEFT = {
  initial: { opacity: 0, x: -60 },
  whileInView: { opacity: 1, x: 0, transition: defaultTransition },
  viewport: { once: true },
};

export const FADE_RIGHT = {
  initial: { opacity: 0, x: 60 },
  whileInView: { opacity: 1, x: 0, transition: defaultTransition },
  viewport: { once: true },
};

export const FADE = {
  initial: { opacity: 0 },
  whileInView: { opacity: 1, transition: defaultTransition },
  viewport: { once: true },
};

export const SCALE_RIGHT = {
  initial: { scaleX: 0 },
  whileInView: {
    transformOrigin: "left",
    scaleX: 1,
    transition: defaultTransition,
  },
  viewport: { once: true },
};

export const SCALE_DOWN = {
  initial: { scaleY: 0 },
  whileInView: {
    transformOrigin: "left",
    scaleY: 1,
    transition: defaultTransition,
  },
  viewport: { once: true },
};

export const HOVER_SHADOW = {
  whileHover: "hoverShadow",
  variants: {
    hoverShadow: {
      y: -8,
      boxShadow: `rgba(45, 45, 45, 0.09) 0px 2px 2px,
    rgba(49, 49, 49, 0.09) 0px 4px 4px, rgba(42, 42, 42, 0.09) 0px 8px 8px,
    rgba(32, 32, 32, 0.09) 0px 16px 16px, rgba(49, 49, 49, 0.09) 0px 32px 32px,
    rgba(35, 35, 35, 0.09) 0px 64px 64px`,
      transition: {
        stiffness: 100,
        dumping: 30,
        duration: 0.6,
      },
    },
  },
};

export const HOVER_SHADOW_SWIPER = {
  whileHover: "hoverShadow",
  variants: {
    hoverShadow: {
      y: -4,
      boxShadow: `rgba(45, 45, 45, 0.09) 0px 1px 1px,
    rgba(49, 49, 49, 0.09) 0px 2px 2px, rgba(42, 42, 42, 0.09) 0px 10px 10px,
    rgba(32, 32, 32, 0.09) 0px 4px 4px, rgba(49, 49, 49, 0.09) 0px 10px 10px,
    rgba(35, 35, 35, 0.09) 0px 6px 6px`,
      transition: {
        stiffness: 100,
        dumping: 30,
        duration: 0.6,
      },
    },
  },
};

export const combine = (...args) => {
  return deepmerge.all([...args], { clone: false });
};
